import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Redirect, Router, Switch } from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promise from 'redux-promise-middleware';

import reducer from './reducersapp';
import history from './utils/history';
import AuthRoute from './components/AuthRoute/AuthRoute';
import AuthorizedRoute from './components/AuthorizedRoute/AuthorizedRoute';
import Login from './containers/Login/Login';
import Bederr from './containers/Bederr/Bederr';
import StagingLabel from './components/StagingLabel/StagingLabel';
import LanguageSelector from './components/LanguageSelector/LanguageSelector';
import { I18nextProvider } from 'react-i18next';
import i18n from './components/i18n';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.scss';
import './components/i18n';

// Bootstrap JS components for global use
import { Tooltip, Toast, Popover } from 'bootstrap';
window.BootstrapTooltip = Tooltip;
window.BootstrapToast = Toast;
window.BootstrapPopover = Popover;

const store = createStore(
  reducer,
  applyMiddleware(promise, thunkMiddleware)
);

// Función para inicializar Bootstrap JS dinámicamente
const initializeBootstrap = () => {
  import('bootstrap/dist/js/bootstrap.bundle.min.js').then(() => {
    // Bootstrap JS loaded
  });
};

function App() {
  useEffect(() => {
    initializeBootstrap();
    // Re-inicializar Bootstrap al cambiar de ruta
    const unlisten = history.listen(() => {
      initializeBootstrap();
    });
    return () => {
      unlisten();
    };
  }, []);

  return (
    <>
      {process.env.REACT_APP_URL_REST === 'https://api.bemaven.xyz/' && <StagingLabel />}
      <LanguageSelector />
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <Router history={history}>
            <Switch>
              <AuthRoute exact path="/login" component={Login} />
              <AuthorizedRoute path="/" component={Bederr} />
              <Redirect to="/login" />
            </Switch>
          </Router>
        </Provider>
      </I18nextProvider>
    </>
  );
}

export default App;
